import {DroppableItem} from '../types'

export const isOutsideContainer = ({
  droppable,
  e
}: {
  droppable: DroppableItem | undefined
  e: MouseEvent
}): boolean => {
  const containerRect =
    droppable?.container &&
    droppable.element.closest(droppable.container)?.getBoundingClientRect()
  return (
    !!containerRect &&
    (e.pageX < containerRect.left ||
      e.pageX > containerRect.right ||
      e.pageY < containerRect.top ||
      e.pageY > containerRect.bottom)
  )
}
